import React, {useContext, useState} from "react";
import {forms} from "../forms";
import {StepProps} from "../step-props";
import {ScenarioHeader} from "../../../components/Scenario/Header";
import {useErrorDialog} from "../../../utils/hooks/useErrorDialog";
import {strings} from "../../../strings/strings";
import {GreenTarifConfirmDialog} from "../green_forms/InputView/GreenTarifConfirmDialog";
import {StepContext} from "../../../contexts/StepContext";
import {QuotationContext} from "../../../contexts/QuotationContext";
import {MtplQuotation} from "../../../model/quotation";
import {ProcessingContext} from "../../../contexts/ProcessingContext";
import {showOrNotTechnicalWorkPageForGreenCard} from "../../MessagePage";
import * as log from "../../../utils/log";
import {LogFunctionalModule} from "../../../utils/log";
import {calculate, Response} from "../../../api/quotationApiClient";
import {QuoationPackage} from "../../../model/quoationPackage";
import {DurationMomentsMap} from "../../../model/contract";
import moment from "moment";
import {ProductType} from "../../../api/model/common";
import { useHotjar } from "../../../utils/hooks/useHotjar";

export const GreenTarifficationStep = ({step}: StepProps) => {
    const {setTextErrorMessageDialog, setOpenErrorMessageDialog, setTextDetailErrorMessageDialog} = useErrorDialog();
    const {nextStepListener} = useContext(StepContext);
    const {
        quotation,
        setQuotation,
        totalPremium,
        setTotalPremium,
        setPackages,
        setSelectedDeductible,
        setSelectedPackage,
        type
    } =
        useContext<QuotationContext<MtplQuotation>>(QuotationContext);
    const [tariffied, setTariffied] = useState(false);
    const {setProcessingOpen} = useContext(ProcessingContext);

    const { trackHotjar} = useHotjar()

    const onCalculate = (submittedQuotation: MtplQuotation) => {
        if (showOrNotTechnicalWorkPageForGreenCard()) return;
        const date = new Date();
        log.sendLog(date, LogFunctionalModule.STORE_GREEN_CARD, 'INFO', `${step.code}_NEXT_HANDLER`,
            [{quotation: submittedQuotation, currentStep: step.code}], '')
        setProcessingOpen(true);

        setQuotation(submittedQuotation);

        calculate(submittedQuotation, ProductType.GREEN_CARD).then((response: Response) => {
            if (response.success) {
                const quoationPackage: QuoationPackage[] = response.data as QuoationPackage[];
                const defaultPackage: QuoationPackage = quoationPackage[0];
                setPackages(quoationPackage);
                setSelectedDeductible(defaultPackage.deductible);
                setTotalPremium(defaultPackage.premium)
                submittedQuotation.totalPremium = defaultPackage.premium;
                submittedQuotation.mtplContract.endDate = DurationMomentsMap[submittedQuotation.mtplContract.duration](
                    moment(submittedQuotation.mtplContract.startDate)).format("YYYY-MM-DD");
                setQuotation(submittedQuotation);
                setSelectedPackage(defaultPackage);
                setTariffied(true);
                setProcessingOpen(false);

                let event = 'green_card_calculating_result';
                console.log('Google Analytics Event = ' + event);
                // @ts-ignore
                window.dataLayer.push({'event': event});
            } else {
                setProcessingOpen(false);
                setTextErrorMessageDialog(strings.tarifficationErrorMessage);
                setTextDetailErrorMessageDialog(response.errorResponse.text + "; " + response.errorResponse.detailText);
                setOpenErrorMessageDialog(true);
            }

            window.scrollTo(0, 0);
        });
    };

    const onTarifConfirm = () => {

        trackHotjar("confirm-sum", type);
        nextStepListener(quotation);
        setTariffied(false);
    };

    const onRecalculate = () => {
        setTariffied(false);
    };

    return <>
        <ScenarioHeader title={strings.greenCardScrnarioHeader}/>

        {step.forms.map(form => React.createElement(forms[form.code], {
            key: form.code,
            onFormSubmit: onCalculate,
            setOpenErrorMessageDialog,
            setTextErrorMessageDialog
        }))}

        <GreenTarifConfirmDialog amount={totalPremium} open={tariffied}
                                 onClose={onRecalculate} editParametersListener={onRecalculate}
                                 toNextStepListener={onTarifConfirm}/>

    </>;
};